export class KDSTerminal {
    id: number;
    account_id: number;
    name: string;
    connection_code: string;
    hwid: string;
    created_at?: string;    
}
